const formatNumberTol = (tolgeo, docid) => {
  return docidPrefix(tolgeo) + parseInt(docid).toLocaleString()
}

const docidPrefix = (tolgeo) => {
  switch (tolgeo) {
    case 'latam':
      return 'LTM'
    case 'mex':
      return 'TMX'
    default:
      return 'TOL'
  }
}

const normalizeMarkdown = (text) => {
  if (typeof text !== 'string') return ''
  return text.replace(/\n-\s*-\s+/g, '\n  - ')
}

const looksLikeBlockListMarkdown = (text) => {
  if (typeof text !== 'string') return false
  const normalized = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
  const lines = normalized.split('\n')
  return lines.some(line => /^\s*[-*+]\s+/.test(line) || /^\s*\d+\.\s+/.test(line))
}

export { formatNumberTol, docidPrefix, normalizeMarkdown, looksLikeBlockListMarkdown }
